import { Activity, ActivityContentSpaceMembersAdded } from "@/api";

import React from "react";
import { Trans } from "../i18n";
import i18n from "@/i18n";
import { activityAuthorName, activityPeopleNames, spaceLink } from "../feedItemLinks";
import type { ActivityHandler, FeedItemProps } from "../interfaces";

const SpaceMembersAdded: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(paths, activity: Activity): string {
    return paths.spacePath(content(activity).space!.id!);
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity, page, paths }: FeedItemProps) {
    const names = activityPeopleNames(content(activity).members ?? []);
    const space = spaceLink(paths, content(activity).space!);

    if (page === "space") {
      return (
        <Trans
          i18nKey="{{author}} added {{names}} to the space"
          values={{ author: activityAuthorName(activity), names }}
        />
      );
    } else {
      return (
        <Trans
          i18nKey="{{author}} added {{names}} to the <space>{{spaceName}}</space> space"
          values={{ author: activityAuthorName(activity), names, spaceName: content(activity).space?.name }}
          components={{ space }}
        />
      );
    }
  },

  FeedItemContent(_props: { activity: Activity; page: any }) {
    return null;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle({ activity }: { activity: Activity }) {
    return i18n.t("Added you to the {{spaceName}} space", { spaceName: content(activity).space?.name });
  },

  NotificationLocation({ activity }: { activity: Activity }) {
    return content(activity).space!.name!;
  },
};

export default SpaceMembersAdded;

function content(activity: Activity): ActivityContentSpaceMembersAdded {
  return activity.content as ActivityContentSpaceMembersAdded;
}
